import React from "react";
import { CheckCircle } from "lucide-react";
import type { ClinicalApplication } from '../types/home.types';

interface ClinicalApplicationsListProps {
  applications: ClinicalApplication[];
}

export const ClinicalApplicationsList = React.memo(({ applications }: ClinicalApplicationsListProps) => {
  return (
    <div className="bg-white border border-gray-300 rounded-xl shadow-sm hover:shadow-lg hover:-translate-y-1 hover:border-gray-400 transition-all duration-300 p-6 md:p-8">
      <ul className="space-y-3 text-lg font-light text-neutral-700 mb-8 font-inter">
        {applications.map((app, index) => (
          <li key={index} className="flex items-start">
            <CheckCircle className="h-5 w-5 bg-gradient-to-r from-[hsl(var(--color-1))] to-[hsl(var(--color-3))] text-white rounded-full mt-0.5 mr-2 flex-shrink-0" />
            <span className="text-lg font-light text-neutral-700">{app.text}</span>
          </li>
        ))}
      </ul>
      
      <p className="leading-relaxed text-neutral-700 font-inter text-left text-lg font-light">
        With Xenira's expertise in advanced lipid-based delivery systems and proprietary innovations, partners gain a reliable platform to bring differentiated, patient-friendly therapies to market.
      </p>
    </div>
  );
});

ClinicalApplicationsList.displayName = 'ClinicalApplicationsList';
